export const navListData = [
  {
    key: 'home',
    label: '首页',
    width: 138,
    img: require('../NavBarM/img/top.png'),
  },
  {
    key: 'news',
    label: '新闻公告',
    width: 160,
    img: require('../NavBarM/img/news.png'),
  },
  {
    key: 'character',
    label: '角色介绍',
    width: 160,
    img: require('../NavBarM/img/character.png'),
  },
  {
    key: 'story',
    label: '世界观',
    width: 150,
    img: require('../NavBarM/img/story.png'),
  },
  {
    key: 'gallery',
    label: '视听站',
    width: 150,
    img: require('../NavBarM/img/gallery.png'),
  },
  {
    key: 'special',
    label: '游戏特色',
    width: 160,
    img: require('../NavBarM/img/special.png'),
  },
  {
    key: 'artwork',
    label: '同人专区',
    width: 160,
    url: 'https://tongren.papegames.cn',
    img: require('../NavBarM/img/artwork.png'),
  },
  {
    key: 'paperpay',
    label: '支付中心',
    width: 160,
    url: 'https://paperpay.papegames.com/evol?scenecode=official_web_lyzzr',
    img: require('../NavBarM/img/paperpay.png'),
  },
];
